<m-expansion-panel [id]="'dividasPendentes-serasa'"
  [title]="'Dívidas pendentes na Serasa ('+totalizadorDividasPendentesSerasa+')'" [active]="larguraEhSuperiorMin">

  <div *ngIf="dividasPendentesSerasa.resultados.length > 0" class="table-responsive" id="div-table-dividas-serasa">
    <table id="id-table-dividasPendentes-serasa" class="table table-sm table-striped table-borderless" aria-label="Tabela de dívidas pendentes serasa" style="font-size: smaller;">
      <thead>
        <tr>
          <th scope="col">Empresa</th>
          <th scope="col">CNPJ</th>
          <th scope="col">Contrato</th>
          <th scope="col">Data da ocorrência</th>
          <th scope="col">Data da inclusão</th>
          <th scope="col">Valor</th>
          <th scope="col">Natureza</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let divida of dividasPendentesSerasa.resultados; index as i">
          <td>{{ divida.empresaCredora | naoinformado }}</td>
          <td>{{ divida.cnpjCredor | naoinformado }}</td>
          <td>{{ divida.contrato | naoinformado }}</td>
          <td>{{ divida.dataOcorrencia | naoinformado }}</td>
          <td>{{ divida.dataInclusao | naoinformado }}</td>
          <td>{{ divida.valor | moedaReal }}</td>
          <td>{{ divida.natureza | naoinformado }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div *ngIf="dividasPendentesSerasaConvem.resultados.length > 0" class="table-responsive">
    <hr>
    <table id="id-table-dividasPendentes-serasa-convem" class="table table-sm table-striped table-borderless" aria-label="Tabela de dívidas pendentes serasa Convém" style="font-size: smaller;">
      <thead>
        <tr>
          <th scope="col">Empresa credora</th>
          <th scope="col">CNPJ</th>
          <th scope="col">Empresa participante</th>
          <th scope="col">CNPJ</th>
          <th scope="col">Contrato</th>
          <th scope="col">Data da ocorrência</th>
          <th scope="col">Data da inclusão</th>
          <th scope="col">Valor</th>
          <th scope="col">Natureza</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let divida of dividasPendentesSerasaConvem.resultados; index as i">
          <td>{{ divida.empresaCredora | naoinformado }}</td>
          <td>{{ divida.cnpjCredor | naoinformado }}</td>
          <td>{{ divida.empresaParticipante | naoinformado }}</td>
          <td>{{ divida.cnpjParticipante | naoinformado }}</td>
          <td>{{ divida.contrato | naoinformado }}</td>
          <td>{{ divida.dataOcorrencia | naoinformado }}</td>
          <td>{{ divida.dataInclusao | naoinformado }}</td>
          <td>{{ divida.valor | moedaReal }}</td>
          <td>{{ divida.natureza | naoinformado }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div id="id-div-dividasPendentes-serasa-falha"
    *ngIf="listaServicoFalha.length > 0 && (dividasPendentesSerasa.resultados.length == 0 && dividasPendentesSerasaConvem.resultados.length == 0) ">
    {{dividasPendentesSerasa.falhaServico.message}}
  </div>

  <app-alert [id]="'dividasPendentes-serasa-mensagem'" [tipo]="'info'" >
    As dívidas são incluídas/excluídas diretamente pelas empresas credoras clientes, sem qualquer intervenção da Serasa Experian.
  </app-alert>


</m-expansion-panel>
